import { backdropColors } from '@components/layout/colors/backdrop-colors.css'
import { backgroundColors } from '@components/layout/colors/background-colors.css'
import { brandColors } from '@components/layout/colors/brand-colors.css'
import { commonColors } from '@components/layout/colors/common-colors.css'
import { darkColors } from '@components/layout/colors/dark-colors.css'
import { gradientColors } from '@components/layout/colors/gradient-colors.css'
import { HomepageSpaceTypeSlugs } from '@page/home/home.types'
import { HomepageAccentColors } from '@page/listing-type-home/home.types'

export const homeThemeColorOptions: Record<
  HomepageSpaceTypeSlugs,
  HomepageAccentColors
> = {
  [HomepageSpaceTypeSlugs.Pool]: {
    primary: brandColors.darkBlue,
    secondary: commonColors.lightBlue,
    primaryGradient: brandColors.primaryBlue,
    secondaryGradient: gradientColors.pool,
    tryHosting: brandColors.darkBlue,
    check: brandColors.primaryBlue,
    hostOnSwimply: darkColors.pool,
    backdrop: backdropColors.pool,
    mobileOverlay: backgroundColors.skyBlue9,
  },
  [HomepageSpaceTypeSlugs.Igloo]: {
    primary: backgroundColors.igloo3,
    secondary: commonColors.lightBlue,
    primaryGradient: backgroundColors.igloo2,
    secondaryGradient: gradientColors.pool,
    tryHosting: backgroundColors.igloo3,
    check: backgroundColors.igloo2,
    hostOnSwimply: darkColors.pool,
    backdrop: backdropColors.pool,
    mobileOverlay: '#1A140D',
  },
  [HomepageSpaceTypeSlugs.Hoops]: {
    primary: brandColors.hoopsOrange,
    secondary: `${brandColors.hoopsOrange}1A`,
    primaryGradient: brandColors.hoopsOrange,
    secondaryGradient: gradientColors.basketballCourt,
    tryHosting: brandColors.hoopsOrange,
    check: brandColors.hoopsOrange,
    hostOnSwimply: darkColors.basketballCourt,
    backdrop: backdropColors.hoops,
    mobileOverlay: brandColors.hoopsOrange,
  },
  [HomepageSpaceTypeSlugs.Tennis]: {
    primary: brandColors.tennisGreen,
    secondary: commonColors.lightGreen,
    primaryGradient: brandColors.tennisGreen,
    secondaryGradient: gradientColors.tennisCourt,
    tryHosting: brandColors.tennisGreen,
    check: brandColors.tennisGreen,
    hostOnSwimply: darkColors.tennisCourt,
    backdrop: backdropColors.tennis,
    mobileOverlay: brandColors.tennisGreen,
  },
  [HomepageSpaceTypeSlugs.Pickleball]: {
    primary: brandColors.darkBlue,
    secondary: `${brandColors.darkBlue}1C`, // 11%
    primaryGradient: brandColors.darkBlue,
    secondaryGradient: gradientColors.pickleball,
    tryHosting: brandColors.darkBlue,
    check: brandColors.darkBlue,
    hostOnSwimply: darkColors.pickleball,
    backdrop: backdropColors.pickleball,
    mobileOverlay: backdropColors.pickleball,
  },
  [HomepageSpaceTypeSlugs.Home]: {
    primary: '#E6327E',
    secondary: `#E6327E1A`, // 10%
    primaryGradient: '#E6327E',
    secondaryGradient: gradientColors.home,
    tryHosting: '#E6327E',
    check: '#E6327E',
    hostOnSwimply: darkColors.home,
    backdrop: backdropColors.home,
    mobileOverlay: '#E6327E',
  },
  [HomepageSpaceTypeSlugs.PetParks]: {
    primary: brandColors.tennisGreen,
    secondary: commonColors.lightGreen,
    primaryGradient: brandColors.tennisGreen,
    secondaryGradient: gradientColors.tennisCourt,
    tryHosting: brandColors.tennisGreen,
    check: brandColors.tennisGreen,
    hostOnSwimply: darkColors.tennisCourt,
    backdrop: backdropColors.tennis,
    mobileOverlay: brandColors.tennisGreen,
  },
  [HomepageSpaceTypeSlugs.LargeBackyard]: {
    primary: brandColors.yardGreen,
    secondary: brandColors.tennisGreen,
    primaryGradient: brandColors.yardGreen,
    secondaryGradient: gradientColors.tennisCourt,
    tryHosting: brandColors.yardGreen,
    check: brandColors.yardGreen,
    hostOnSwimply: brandColors.tennisGreen,
    backdrop: backdropColors.tennis,
    mobileOverlay: brandColors.yardGreen,
  },
}
